import React, { useEffect, useState } from "react";
import "./navbar.scss";
import { Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../components/loading/Loading";
import { fetchAccount, putAccount } from "../../services/AccountService";
import ViewInWeb from "../../components/Common/ViewInWeb";
import meliLogo from "../../assets/images/logo_meli_2.png";
import axios from "axios";
import { Constants } from "src/Constants";

type nav = {
  id?: number;
  nombre: string;
  url: string;
}

function Navbar() {
  const [loading, setLoading] = useState(false);
  const [navbar, setNavbar] = useState<nav[]>([]);
  const [newNavbar, setNewNavbar] = useState<nav[]>([]);
  const [newElement, setNewElement] = useState<nav>()

  const instance = axios.create({ baseURL: Constants.BASE_URL });

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    try {
      setLoading(true);
      const resp = await instance.get('/navbar');
      setNavbar(resp.data.data)
      setNewNavbar(resp.data.data)
      setLoading(false);
    } catch (error: any) {
      console.log(error);
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const save = async () => {
    setLoading(true);
    if(newElement?.nombre && newElement.url){
      newNavbar.push(newElement)
    }
    try {
      setLoading(false);
      await instance.post('/navbar', {
        navbar: newNavbar
      });
      toast(`Seccíon guardada con éxito`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
      setNewElement({
        nombre: '',
        url: ''
      })
      fetch()
    } catch (error) {
      setLoading(false);
      toast.error(`Ocurrió un error al procesar la solicitud, reintentar`, {
        position: toast.POSITION.BOTTOM_CENTER,
        pauseOnHover: false,
      });
    }
  };

  const handleChange = (id: number, field: any, value: string) => {
    const newNavbarcpy = newNavbar.map((n: any) => {
      if(n.id === id){
        n[field] = value
      }
      return n
    })
    setNewNavbar(newNavbarcpy)
  }

  return (
    <React.Fragment>
      <ToastContainer />
      {loading && <Loading />}
      <div className="page-content" id="Config">
        <Container fluid={true}>
          <Breadcrumb title="Navbar" breadcrumbItem="Navbar" />
          <Row>
            <Col>
              <div className="row">
                {
                  navbar?.map(nav => (
                    <div className="col-2">
                      <FormGroup className="mb-2">
                        <Input
                          value={nav.nombre}
                          className="mb-2"
                          onChange={(e) => handleChange(nav.id!, 'nombre', e.target.value)}
                        />
                        <Input
                          value={nav.url}
                          className="mb-2"
                          onChange={(e) => handleChange(nav.id!, 'url', e.target.value)}
                        />
                      </FormGroup>
                    </div>
                  ))
                }
              </div>
            </Col>
          </Row>
          <Row style={{ marginTop: "2rem" }}>
            <Col>
              <div className="row" style={{ marginTop: "1rem" }}>
                <div className="col-12 text-right">
                  <ViewInWeb link="https://mariomendez.uy/" />
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => save()}
                  >
                    Guardar
                  </button>
                </div>
              </div>
            </Col>
          </Row>
          {
            /*
          <Row style={{ marginTop: "2rem" }}>
            <Col>
              <div className="row" style={{ marginTop: "1rem" }}>
                <div className="col-3">
                  <h4>Agregar nuevo elemento</h4>
                  <FormGroup className="mb-2">
                        <Input
                          value={newElement?.nombre}
                          className="mb-2"
                          onChange={(e) => setNewElement({
                            nombre: e.target.value.trim(),
                            url: newElement?.url.trim() || ''
                          })}
                          placeholder="Nombre"
                        />
                        <Input
                          value={newElement?.url}
                          className="mb-2"
                          onChange={(e) => setNewElement({
                            nombre: newElement?.nombre.trim() || '',
                            url: e.target.value.trim(),
                          })}
                          placeholder="Url"
                        />
                      </FormGroup>
                  <button
                    className="btn btn-primary waves-effect waves-light"
                    onClick={() => save()}
                  >
                    Agregar nuevo elemento
                  </button>
                </div>
              </div>
            </Col>
          </Row>
          */}
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Navbar;
